import { fetcher } from '@commenda/utils';
import {
  ComplianceMonitorCorporationAdditionalOnboardingStep,
  ComplianceMonitorCorporationInfoMethod,
  ComplianceMonitorCorporationInfoOnboardingStatus,
  ComplianceMonitorCorporationInfoOnboardingVersionV1Step,
} from './compliance-monitor.types';

export type ComplianceCalendarOnboardingUpdateProp = {
  onboardingInformation?: {
    // Advance a single step, or declare a whole-onboarding transition via `status`.
    step?: ComplianceMonitorCorporationInfoOnboardingVersionV1Step;
    // `COMPLETED` marks every onboarding step finished (server-reconciled).
    status?: ComplianceMonitorCorporationInfoOnboardingStatus;
    complianceMethod?: ComplianceMonitorCorporationInfoMethod;
    defaultAssigneeUserIds?: string[];
  };
  complianceSpecificOnboardingInformation?: {
    step: ComplianceMonitorCorporationAdditionalOnboardingStep;
  };
};

export async function updateComplianceMonitor(
  corporationId: number,
  body: ComplianceCalendarOnboardingUpdateProp
): Promise<Response | null> {
  return fetcher(`compliance-monitors/${corporationId}`, {
    method: 'POST',
    body,
  });
}
